import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom'
import { AppLayout } from './components/Layout'
import { HomePage } from './pages/Home'
import { DashboardPage } from './pages/Dashboard'
import { ProofPage } from './pages/Proof'
import { RiskPage } from './pages/Risk'
import { JournalPage } from './pages/Journal'
import { PricingPage } from './pages/Pricing'
import { NotFoundPage } from './pages/NotFound'

export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route element={<AppLayout />}>
          <Route index element={<HomePage />} />
          <Route path="dashboard" element={<DashboardPage />} />
          <Route path="proof" element={<Navigate to="/proof/grok-alpha" replace />} />
          <Route path="proof/:id" element={<ProofPage />} />
          <Route path="risk" element={<RiskPage />} />
          <Route path="journal" element={<JournalPage />} />
          <Route path="pricing" element={<PricingPage />} />
          <Route path="*" element={<NotFoundPage />} />
        </Route>
      </Routes>
    </BrowserRouter>
  )
}
